module.exports = __webpack_public_path__ + "static/media/storeOwnersEditDemo.20fd54c5.mp4";